import {Project} from '../model/Project';
import {v4 as uuidv4} from 'uuid';
export const commuterApp: Project = {
  id: uuidv4(),
  label: 'Commuter',
  description: 'More info coming soon...',
};
